import React, { useState } from 'react';
import './ShareButtons.css';

const ShareButtons = ({ url }) => {
  const [showToast, setShowToast] = useState(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(url);
      showToastMessage();
    } catch (err) {
      // 降级方案
      const textArea = document.createElement('textarea');
      textArea.value = url;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      showToastMessage();
    }
  };

  const showToastMessage = () => {
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  return (
    <div className="share-container">
      <div className="share-url-box">
        <input 
          type="text" 
          value={url} 
          readOnly 
          className="url-input"
          onClick={(e) => e.target.select()}
        />
        <button 
          className="copy-btn"
          onClick={copyToClipboard}
          title="复制链接"
        >
          📋 复制
        </button>
      </div>
      
      {showToast && (
        <div className="toast">
          🎉 分享给朋友们看看
        </div>
      )}
    </div>
  );
};

export default ShareButtons;